import { StyleSheet } from 'react-native'
import { disabledGray, toqueColor } from '../../theme/colors'

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 24,
  },

  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    color: disabledGray,
    fontSize: 18,
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  alertIcon: {
    backgroundColor: toqueColor,
    borderRadius: 50,
    height: 12,
    width: 12,
    position: 'absolute',
    right: 0,
  },
})
